export const BlockColors = [
  'black',
  // 'white',
  'yellow',
  'orange',
  // 'green',
  'blue',
] as const;

export const BlockShapes = [
  { shape: 'square' },
  { shape: 'circle' },
  { shape: 'quarter-circle', orientation: 'top-left' },
  { shape: 'quarter-circle', orientation: 'top-right' },
  { shape: 'quarter-circle', orientation: 'bottom-left' },
  { shape: 'quarter-circle', orientation: 'bottom-right' },
] as const;

export type SquareBlockConfiguration = Extract<
  (typeof BlockShapes)[number],
  { shape: 'square' }
>;

export type CircleBlockConfiguration = Extract<
  (typeof BlockShapes)[number],
  { shape: 'circle' }
>;

export type QuarterCircleBlockConfiguration = Extract<
  (typeof BlockShapes)[number],
  { shape: 'quarter-circle' }
>;

export type BlockConfiguration = {
  color: (typeof BlockColors)[number];
  shape:
    | SquareBlockConfiguration
    | CircleBlockConfiguration
    | QuarterCircleBlockConfiguration;
};
